<template>
    <div>
        <modal :show.sync="viewMessage" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Información adicional</h6>
                <div class="alert alert-info mt-2">
                    <span>{{ informationalMessage }}</span>
                </div>
            <template slot="footer">
                <div class="right-side">
                    <p-button type="default" link @click="cancelOpenMessage()">Aceptar</p-button>
                </div>
            </template>
        </modal>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    Datos flujo de caja
                </h6>
                <p-button @click="openMessage()" v-if="informationalMessage" class="top-right-button" type="primary"><i class="fa fa-cube"></i></p-button>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Departamento actividad *</label>
                    <fg-input   tabindex="1"
                                name="departamento"
                                v-validate="modelValidations.state"
                                :error="getError('departamento')"
                                v-model="form.state">
                            <el-select
                                    filterable
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.state">
                            <el-option v-for="(state,index) in states" :key="index"
                                    class="select-warning"
                                    :value="state"
                                    :label="state">
                                    <span style="float: left">{{ state }}</span>
                                    <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ activity.code }}</span> -->
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Municipio de actividad *</label>
                    <fg-input   tabindex="2"
                                name="municipio"
                                v-validate="modelValidations.city"
                                :error="getError('municipio')"
                                v-model="form.city">
                            <el-select
                                    filterable
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.city">
                            <el-option v-for="(city,index) in cities" :key="index"
                                    class="select-warning"
                                    :value="city"
                                    :label="city">
                                    <span style="float: left">{{ city }}</span>
                                    <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ activity.code }}</span> -->
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Plan de pago *</label>
                    <fg-input   tabindex="3"
                                name="plan de pago"
                                v-validate="modelValidations.paymentPlan"
                                :error="getError('plan de pago')"
                                v-model="form.paymentPlan">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.paymentPlan">
                            <el-option
                                    class="select-warning"
                                    value="Fija"
                                    label="Fija">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Pactada"
                                    label="Pactada">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo de crédito *</label>
                    <fg-input   tabindex="4"
                                name="tipo de crédito"
                                v-validate="modelValidations.clientType"
                                :error="getError('tipo de crédito')"
                                v-model="form.clientType">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.clientType">
                            <el-option v-for="clientType in $store.getters.getClientTypes" :key="clientType.id"
                                    class="select-warning"
                                    :value="clientType.id"
                                    :label="clientType.name">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Plazo máximo sugerido *</label>
                    <fg-input   disabled
                                tabindex="5"
                                type="number"
                                name="plazo máximo"
                                autocomplete="off"
                                v-validate="modelValidations.maxTerm"
                                :error="getError('plazo máximo')"
                                v-model="form.maxTerm">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Plazo pactado con cliente *</label>
                    <fg-input   tabindex="6"
                                type="number"
                                name="plazo pactado"
                                autocomplete="off"
                                v-validate="modelValidations.clientTerm"
                                :error="getError('plazo pactado')"
                                v-model="form.clientTerm">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Fecha de primer pago *</label>
                    <el-date-picker
                        name="fecha primer pago"
                        v-validate="modelValidations.firstPaymentDate"
                        format="dd/MM/yyyy"
                        v-model="form.firstPaymentDate"
                        type="date"
                        :picker-options="pickerOptions"
                        placeholder="Seleccione fecha de primer pago">
                    </el-date-picker>
                    <span v-show="errors.has('fecha primer pago')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('fecha primer pago') }}
                    </span>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="saveData()" type="warning">Siguiente</p-button>
                    <p-button @click="toPersonalData()" type="default" class="pull-left mb-3">Atrás</p-button>
                </div>
            </div>
        </card>
    </div>
</template>
    <script>
    import { Card, Modal } from 'src/components/UIComponents'
    import swal from 'sweetalert2'
    import Vue from 'vue'
    import {Select, Option, DatePicker} from 'element-ui'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import moment from 'moment'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import departments from 'src/util/Others/States'
    import { parse } from 'expression-eval'
    import { amountTermsFa } from '../../../../../../api/graphql/queries/setup/AllAmountTermsFA'
    import { amountTermsWc } from '../../../../../../api/graphql/queries/setup/AllAmountTermsWC'
    import { Validator } from "vee-validate";

    Validator.extend("min_date_today", {
        getMessage: field => `El campo ${field} no puede tener fecha menor o igual a hoy.`,
        validate: value => {
            // Expresión regular para detectar emojis más robusta
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Para evitar problemas con la hora
            const selectedDate = new Date(value);
            return selectedDate > today;
        }
    });

    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            Modal,
            VueNumeric,
            PSwitch,
            [DatePicker.name]: DatePicker,
        },
        data() {
        return {
            cashFlowData: {
                daysDifference: null,
                months: []
            },
            viewMessage: false,
            amountTermsFa: null,
            amountTermsWc: null,
            validateSalary: false,
            layoffsDays: 0,
            extraPaymentDays: 0,
            consumer: false,
            microcredit: false,
            pequenia_empresa: false,
            agro: false,
            username: '',
            password: '',
            auth_system: '',
            subcategory: '',
            amount: '',
            states: [],
            cities: [],
            modelValidations: {
                state: {
                    required: true
                },
                city: {
                    required: true
                },
                paymentPlan: {
                    required: true
                },
                clientType: {
                    required: true
                },
                maxTerm: {
                    required: true,
                    numeric: true, 
                    min: 1,
                    max: 99,
                },
                clientTerm: {
                    required: true,
                    numeric: true, 
                    between: [1,999]
                },
                firstPaymentDate: {
                    required: true,
                    min_date_today: true
                },
                customerPrincipalActivity: {
                    required: false, 
                    max: 32
                },
                requestDataAmount: {
                    required: true
                },
                customerSalary: {
                    required: true
                },
                requestData: {
                    required: true
                }
            },
            form: {
                state: null,
                city: null,
                paymentPlan: null,
                clientType: null,
                maxTerm: null,
                clientTerm: null,
                firstPaymentDate: null,
                principalActivity: null

            },
            pickerOptions: {
                // Deshabilitar fechas anteriores a hoy
                disabledDate(date) {
                    // Obtener la fecha actual sin la hora
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    // Deshabilitar todas las fechas anteriores a hoy
                    return date < today;
                }
            },
        }
        },
        watch: {
            // Observa los cambios en form.clientType
            'form.clientType': function(newClient,oldVal) {
                if(oldVal == null && this.form.firstPaymentDate != null){
                    return
                }
                this.form.clientTerm = null;
                const selectedClient = this.$store.getters.getClientTypes.find(clientType => clientType.id === newClient);
                const selectedClientTypeName = selectedClient ? selectedClient.name : '';
                
                const selectedDestiny = this.$store.getters.getCreditPurposes.find(creditPurpose => creditPurpose.id === this.$store.state.assesments[this.$store.state.actualAssesment].creditPurpose);
                const selectedDestinyName = selectedDestiny ? selectedDestiny.name : '';
                
                const amount = parseFloat(this.$store.state.assesments[this.$store.state.actualAssesment].amount); // Asegurarse de que amount sea numérico
                if(selectedDestinyName == 'Activo fijo') {
                    // Buscar el intervalo en el que cae el 'amount'
                    const term = this.amountTermsFa.find(term => {
                        const from = parseFloat(term.data.from);
                        const to = parseFloat(term.data.to);
                        return amount >= from && amount <= to;
                    });
                    var maxTerm = null;
                    // Si encontramos el intervalo y el cliente es válido
                    if (term && selectedClientTypeName in term.data) {
                        // Obtener el valor correspondiente al cliente
                        maxTerm = term.data[selectedClientTypeName];
                    }
                    else {
                        this.showNotificationError('El monto solicitado no tiene parametrización de montos y plazos');
                    }
                    this.form.maxTerm = maxTerm;
                }
                else if(selectedDestinyName == 'Capital de trabajo') {
                    // Buscar el intervalo en el que cae el 'amount'
                    const term = this.amountTermsWc.find(term => {
                        const from = parseFloat(term.data.from);
                        const to = parseFloat(term.data.to);
                        return amount >= from && amount <= to;
                    });
                    var maxTerm = null;
                    // Si encontramos el intervalo y el cliente es válido
                    if (term && selectedClientTypeName in term.data) {
                        // Obtener el valor correspondiente al cliente
                        maxTerm = term.data[selectedClientTypeName];
                    }
                    else {
                        this.showNotificationError('El monto solicitado no tiene parametrización de montos y plazos');
                    }
                    this.form.maxTerm = maxTerm;
                }


            },
            // Observa los cambios en form.state
            'form.state': function(newState,oldVal) {
                if(oldVal == null && this.form.firstPaymentDate != null){
                    return
                }
                // Filtra los municipios que pertenecen al estado seleccionado
                this.form.city = null;
                this.cities = departments
                    .filter(dept => dept.Departamento === newState)
                    .map(dept => dept.Municipio);
            },
            // Observa los cambios en form.clientTerm
            'form.clientTerm': function(newClientTerm) {
                const selectedClient = this.$store.getters.getClientTypes.find(clientType => clientType.id === this.form.clientType);
                const selectedClientTypeName = selectedClient ? selectedClient.name : '';
                if (parseFloat(newClientTerm) > parseFloat(this.form.maxTerm)) {
                    swal({
                        title: 'Atención',
                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                        // text: `El valor máximo a pactar para clientes ${selectedClientTypeName} es ${this.form.maxTerm}, corrige y continua`,
                        text: `Plazo no permitido para el monto y tipo de cliente ingresado`,
                        type: 'info',
                        showCancelButton: false,
                        confirmButtonText: 'Continuar',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        buttonsStyling: false
                    });
                    // Establecer el valor de 'clientterm' en null
                    this.form.clientTerm = null;
                }
                this.calculateCashFlowData(this.form.firstPaymentDate);
            },
            // Observa los cambios en form.state
            'form.firstPaymentDate'(newDate) {
                if (newDate) {
                    this.calculateCashFlowData(newDate);
                }
            }
            
            
        },
        computed: {
            informationalMessage() {
                if (!this.cashFlowData.daysDifference || this.cashFlowData.months.length === 0) {
                    return '';
                }

                const firstMonth = this.cashFlowData.months[0].name;
                const lastMonth = this.cashFlowData.months[this.cashFlowData.months.length - 1].name;

                return `Existen ${this.cashFlowData.daysDifference} días de desfase entre la evaluación y la fecha de primer pago. El flujo de caja inicia en ${firstMonth} y finaliza en ${lastMonth}.`;
            }
            
        },
        methods: {
            openMessage(){
                this.viewMessage = true;
            },
            cancelOpenMessage(){
                this.viewMessage = false;
            },
            calculateCashFlowData(futureDate) {
                // Obtener la fecha actual
                const today = new Date();
                const selectedDate = new Date(futureDate);

                // Validar que la fecha sea futura
                if (selectedDate <= today) {
                    this.cashFlowData.daysDifference = null;
                    this.cashFlowData.months = [];
                    return;
                }

                // Calcular la diferencia en días
                const differenceInMs = selectedDate - today;
                const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
                this.cashFlowData.daysDifference = differenceInDays;

                // Generar la lista de meses
                this.generateMonthsList(selectedDate);
            },
            // generateMonthsList(startDate) {
            //     const monthsList = [];
            //     const numberOfMonths = this.form.clientTerm; // Cantidad de meses a generar

            //     let currentDate = new Date(startDate);

            //     for (let i = 0; i < numberOfMonths; i++) {
            //         const monthNumber = currentDate.getMonth() + 1; // Mes (de 1 a 12)
            //         const year = currentDate.getFullYear(); // Año completo
            //         const monthName = this.getMonthName(monthNumber); // Nombre del mes en español

            //         // Formatear el nombre del mes
            //         const formattedMonth = `${monthName}/${year.toString().slice(-2)}`;

            //         // Agregar al array
            //         monthsList.push({
            //         name: formattedMonth,
            //         month: monthNumber,
            //         year: year,
            //         });

            //         // Avanzar un mes
            //         currentDate.setMonth(currentDate.getMonth() + 1);
            //     }

            //     this.cashFlowData.months = monthsList;
            //     console.log(monthsList);
            // },
            generateMonthsList(startDate) {
                const monthsList = [];
                const numberOfMonths = this.form.clientTerm; // Cantidad de meses a generar
                let currentDate = new Date(startDate);

                for (let i = 0; i < numberOfMonths; i++) {
                    const monthNumber = currentDate.getMonth() + 1; // Mes (de 1 a 12)
                    const year = currentDate.getFullYear(); // Año completo
                    const monthName = this.getMonthName(monthNumber); // Nombre del mes en español

                    // Formatear el nombre del mes
                    const formattedMonth = `${monthName}/${year.toString().slice(-2)}`;

                    // Agregar al array
                    monthsList.push({
                        name: formattedMonth,
                        month: monthNumber,
                        year: year,
                    });

                    // Ajustar la fecha para evitar el salto inesperado de mes
                    const day = currentDate.getDate();
                    currentDate.setDate(1); // Ir al primer día del mes
                    currentDate.setMonth(currentDate.getMonth() + 1); // Avanzar un mes
                    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
                    currentDate.setDate(Math.min(day, lastDay)); // Ajustar el día si es mayor al último del mes
                }

                this.cashFlowData.months = monthsList;
            },
            getMonthName(monthNumber) {
                const months = [
                    'Enero',
                    'Febrero',
                    'Marzo',
                    'Abril',
                    'Mayo',
                    'Junio',
                    'Julio',
                    'Agosto',
                    'Septiembre',
                    'Octubre',
                    'Noviembre',
                    'Diciembre',
                ];
                return months[monthNumber - 1];
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (product.name.toLowerCase() == 'consumo') {
                    this.consumer = true;
                    this.microcredit = false;
                    this.pequenia_empresa = false;
                    this.agro = false;
                    this.customerStudyActivity = '';
                    this.customerStudySubcategory = '';
                    if (this.$store.state.isCustomer) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                            var purpose = this.$store.getters.getCreditPurposes.find(purpose => purpose.name.toLowerCase() == 'libre inversión' || purpose.name.toLowerCase() == 'libre inversion');
                            this.requestCreditPurpose = purpose.id;
                        }
                    }
                }
                else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                    this.microcredit = true;
                    this.consumer = false;
                    this.pequenia_empresa = false;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.pequenia_empresa = true;
                    this.microcredit = true;
                    this.consumer = false;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'agropecuario') {
                    this.pequenia_empresa = false;
                    this.microcredit = false;
                    this.consumer = false;
                    this.agro = true;
                }
                
            },
            
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            changeProductType () {
                this.$store.dispatch('resetBalance');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /***
            * Función para mostrar un mensaje de éxito
            */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toPersonalData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveData () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        var vm = this;
                        vm.$store.dispatch('setCashFlow', { form: vm.form, cashFlowData: vm.cashFlowData }).then(()=>{
                            const routes = [
                                { 
                                    title: '¿Deseas agregar información al FM100?', 
                                    text: 'Si aceptas, podrás agregar o editar la información del formulario FM100', 
                                    route: '/asessments/new_asessment/customer/fm100' 
                                },
                                { 
                                    title: '¿Deseas agregar Inventario agrícola y pecuario?', 
                                    text: 'Si aceptas, podrás agregar o editar la información del inventario agrícola y pecuario', 
                                    route: '/asessments/new_asessment/customer/agro/inventory' 
                                },
                                { 
                                    title: '¿Deseas agregar información de Inmuebles?', 
                                    text: 'Si aceptas, podrás agregar o editar la información de los inmuebles', 
                                    route: '/asessments/new_asessment/customer/agro/estate' 
                                },
                                {
                                    title: '¿Deseas agregar Instalaciones / Otros Activos Agropecuarios?',
                                    text: 'Si aceptas, podrás agregar o editar la información de Construcciones desmontables / Herramientas / Maquinaria y Equipo',
                                    route: '/asessments/new_asessment/customer/agro/machinery'
                                },
                                {
                                    title: '¿Deseas agregar Rendimientos históricos?',
                                    text: 'Si aceptas, podrás agregar o editar la información de cultivos a cosechar durante el ciclo a financiar',
                                    route: '/asessments/new_asessment/customer/agro/historical_yields'
                                },
                                {
                                    title: '¿Deseas agregar Ingresos por ventas de productos almacenados?',
                                    text: 'Si aceptas, podrás agregar o editar la información de Agrícolas / Pecuarios / Animales durante el ciclo a financiar',
                                    route: '/asessments/new_asessment/customer/agro/product'
                                },
                                {
                                    title: '¿Deseas agregar Ingresos por ventas estacionales?',
                                    text: 'Si aceptas, podrás agregar o editar la información de Ingresos por ventas estacionales',
                                    route: '/asessments/new_asessment/customer/agro/seasonal_sales'
                                },
                                {
                                    title: '¿Deseas agregar Ingresos por jornales o salarios a la actividad agropecuaria?',
                                    text: 'Si aceptas, podrás agregar o editar la información de Ingresos por jornales o salarios a la actividad agropecuaria',
                                    route: '/asessments/new_asessment/customer/agro/salary'
                                }
                            ];
                            let currentIndex = 0;
                            function askRoute() {
                                if (currentIndex < routes.length) {
                                    const current = routes[currentIndex];
                                    swal({
                                        title: current.title,
                                        text: current.text,
                                        type: 'info',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        vm.$router.push(current.route); // Redirige a la ruta correspondiente
                                    }, (dismiss) => {
                                        if (dismiss === 'cancel') {
                                            currentIndex++; // Avanza al siguiente paso
                                            askRoute(); // Llama recursivamente para mostrar la siguiente pregunta
                                        } else {
                                            swal({
                                                title: 'Cancelado',
                                                text: 'El analista no ha continuado',
                                                type: 'error',
                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                buttonsStyling: false
                                            });
                                        }
                                    });
                                } else {
                                    vm.$router.push('/asessments/new_asessment/customer/agro/expenses');
                                }
                            }
                            // Llama la función para iniciar el flujo
                            askRoute(); 
                        });
                    }
                    else {
                        this.showNotificationError('El formulario no está completo');
                    }
                })
                
                
            }
        },
        mounted() {
             // Extraer los departamentos únicos
            const uniqueDepartments = [...new Set(departments.map(dept => dept.Departamento))];
            // Asignar el resultado a this.states
            this.states = uniqueDepartments;
            this.amountTermsFa = this.$store.getters.getAmountTermsFa;
            this.amountTermsWc = this.$store.getters.getAmountTermsWc;
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlow) {
                    this.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlow;
                }
                this.form.principalActivity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].principalActivity;
            }
            else if (this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlow) {
                    this.form = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlow;
                }
                this.form.principalActivity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].principalActivity
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlow) {
                    this.form = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlow;
                }
                this.form.principalActivity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].principalActivity
            }
        }
    }
</script>
<style>
.top-right-button {
  position: absolute;
  top: 10px; /* Ajusta el espacio desde el borde superior */
  right: 10px; /* Ajusta el espacio desde el borde derecho */
}
</style>
